import { Th as ChakraTh } from "@chakra-ui/react";

export function Th({ label }) {
  return (
    <ChakraTh padding=".3rem" paddingInline=".6rem" textAlign="center">
      {label}
    </ChakraTh>
  );
}
